import "@/App.css";
import {
  createBrowserRouter,
  RouterProvider,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Support from "@/pages/Support";
import Contact from "@/pages/Contact";
import InfoPage from "@/pages/InfoPage";
import PersonalTraining from "@/pages/PersonalTraining";
import Macros from "@/pages/Macros";
import AdminMealsPage from "@/pages/AdminMealsPage";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/admin/meals" element={<AdminMealsPage />} />
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/support" element={<Support />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/personal-training" element={<PersonalTraining />} />
        <Route path="/macros" element={<Macros />} />
        <Route path="/info/:slug" element={<InfoPage />} />
        <Route path="*" element={<Home />} />
      </Route>
    </Route>
  )
);

export default function App() {
  return (
    <>
      <RouterProvider router={router} />
      <Toaster position="bottom-right" richColors />
    </>
  );
}
